import React, { useState, useEffect } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';
import DateRangePickerComponent from '../../components/date-range';
import '../../assets/stylesheet/res.scss';
import ReactPaginate from 'react-paginate';
import Speedometer from '../../components/speedometerChart';
import StackedSingleBarChart from '../../components/stackedSingleBarChart';
import ApiRequest from '../../services/apiService';
import { ShowToastUtil } from '../../utilities/showToastUtil';
import { useLocation } from 'react-router-dom';
import baseUrl from '../../services/baseUrl';
import GetUserData from '../../utilities/getUserDetails';
import MyMultiSelectDropdown from "../../utilities/multiSelectInputType";
import SingleSelectSobDropDown from '../Dashboard/DropDownSelectSobInputType';
import SingleSelectTouchpointDropdown from '../Dashboard/DropDownSelectTouchpointInputType';
import '../../assets/stylesheet/multiSelectInputType.css';
import ScreenLoader from '../../components/screenLoader';
import { Button } from 'react-bootstrap';


function Touchpoint() {

    // table configuration and option start
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });
    const [parentChartData, setParentChartdata] = useState([]);
    const [ChildChartData, setChildChartdata] = useState([]);
    const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
    const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
    const [isAllTouchPoints, setIsAllTouchpoints] = useState(
        (localStorage.getItem('touchpointFilter') || localStorage.getItem('isAllTouchpoints')) ? true : false
    );
    const [viewFilter, setViewFilter] = useState('groupView');
    const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || "");
    const [projects, setProjects] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [IsLoading, setIsLoading] = useState(false);
    const [selectedGroupName, setSelectedGroupName] = useState('');

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const params = new URLSearchParams({
                quickFilterRange: quickFilter,
                fromDate: localStorage.getItem('fromDate') || fromDate,
                toDate: localStorage.getItem('toDate') || toDate,
                projectFilter: projectFilter||'',
                viewFilter: viewFilter,
                userCode: GetUserData().UserCode,
                userRole: GetUserData().UserRole,
                touchpointFilter: touchpointFilter,
                sobFilter: sobFilter,
                selectedGroupName: selectedGroupName
            });
            const url = `${baseUrl()}/nps/GetTouchpointData?${params.toString()}`;
            try {
                const response = await ApiRequest({
                    apiLink: url,
                    method: "GET",
                });
                if (response.Message === 'Success') {
                    setIsLoading(false);

                    setParentChartdata(response.Data.TouchpointParentDataList);
                    setChildChartdata(response.Data.TouchpointChildDataList);
                    setProjects(response.Data.Projects);
                } else {
                    ShowToastUtil("Something went wrong", "error");
                }
            } catch (error) {
                console.error("Error during API request:", error);
            }
        } catch (error) {
            ShowToastUtil("Failed to fetch data. Please try again later.", "error");
        }
    };
    useEffect(() => {
        fetchData();
    }, [viewFilter, quickFilter, projectFilter, fromDate, toDate, sobFilter, touchpointFilter, selectedGroupName]);

    const getNpsColor = (npsScore) => {
        if (npsScore <= 0) {
            return "#008000";
        }
        if (npsScore > 0 && npsScore <= 50) {
            return "#f10000";
        }
        if (npsScore > 50) {
            return "#008000";
        }
    };

    const handleViewSelect = (e) => {
        setViewFilter(e.target.value);
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0); // Reset to the first page on search
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handlePageSizeChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(0); // Reset to the first page on page size change
    };

    const sortedData = [...ChildChartData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const filteredData = sortedData.filter(item => {
        const searchLower = searchTerm.toLowerCase();
        return Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchLower)
        );
    });

    const paginatedData = filteredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    const [isScrolled, setIsScrolled] = useState(false);


    const handleDateRangeFilter = (startDate, endDate) => {
        if (startDate && endDate) {
            setFromDate(startDate.toISOString().split("T")[0]);
            setToDate(endDate.toISOString().split("T")[0]);
            setQuickFilter("");
        } else {
            setFromDate("");
            setToDate("");
        }
        localStorage.setItem('quickFilter', '');
        localStorage.setItem('fromDate', startDate.toISOString().split("T")[0]);
        localStorage.setItem('toDate', endDate.toISOString().split("T")[0]);
        // window.location.reload();
    };
    //QuickFilters
    const handleQuickFilter = async (event) => {
        const selectedValue = event.target.value;
        setFromDate('');
        setToDate('');
        setQuickFilter(selectedValue);
        localStorage.setItem('fromDate', '');
        localStorage.setItem('toDate', '');
        localStorage.setItem('quickFilter', selectedValue);
        window.location.reload();
    };
    const handleScroll = () => {
        if (window.scrollY > 50) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);
        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const handleTouchpointFilter = (touchpoint) => {
        setTouchpointFilter(touchpoint);
        localStorage.setItem("touchpointFilter", touchpoint);
    }
    const handleSobFilter = (sob) => {
        setSobFilter(sob);
        localStorage.setItem("sobFilter", sob);
    }

    const handleAllTouchpointSelect = (isSelected) => {
        setSobFilter('');
        setIsAllTouchpoints(isSelected);
    }

    const handleProjectFilter = (event) => {
        const selectedOption = event.target.value;
        setProjectFilter(selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.setItem('projectFilter', selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.removeItem("sobFilter");
        localStorage.removeItem("touchpointFilter");
        window.location.reload();
      };

      const onGroupNameClick = (groupName) => {
          const selectedGroup = groupName;
          setSelectedGroupName(selectedGroup);
      };
      const handleCustomerGroupBackBtn = () =>{
        setSelectedGroupName('');
      }
      return (
        <>
            {IsLoading ? (
                <div className="screenLoader">
                    <ScreenLoader />
                </div>
            ) : (
                <section className='container-fluid'>
                    <div className='Page-title d-flex align-items-center'>
                        <h3 className='mb-2'>Touchpoint</h3>
                        <div className='ms-2 mt-1'>
                            <div className="did-floating-label-content me-1 mb-0">
                            <select
                            className="did-floating-select w-150px h-300"
                            value={projectFilter}
                            onChange={handleProjectFilter}
                            >
                            {projects.map((project) => (
                                <option
                                key={project.ProjectId}
                                value={project.ProjectId}
                                >
                                {project.ProjectName}
                                </option>
                            ))}
                            </select>
                            <label className="did-floating-label">
                            Project Filter
                            </label>
                        </div>
                        </div>
                        <div
                            className="ms-1 mt-1">
                            <SingleSelectSobDropDown
                                onSobSelect={handleSobFilter}
                                onAllTouchpointSelect={handleAllTouchpointSelect}
                            />
                        </div>
                        <div
                            className={
                                (!isAllTouchPoints)
                                    ? "d-none did-floating-label-content mb-0"
                                    : "did-floating-label-content mb-0"
                            }>
                            <SingleSelectTouchpointDropdown
                                onTouchPointSelect={handleTouchpointFilter}
                            />
                        </div>
                        <div className='card-option ms-auto d-flex mt-1 pb-1'>
                            <div className="did-floating-label-content me-2 mb-0">
                                <select
                                    className="did-floating-select w-100px h-30"
                                    value={quickFilter}
                                    onChange={handleQuickFilter}
                                >
                                    <option value={""}>Select Filter</option>
                                    <option>FTD</option>
                                    <option>WTD</option>
                                    <option>MTD</option>
                                    <option>QTD</option>
                                    <option>YTD</option>
                                </select>
                                <label className="did-floating-label">
                                    Quick Filter
                                </label>
                            </div>
                            <div className='did-floating-label-content mb-0'>
                                <DateRangePickerComponent
                                    onRangeSelect={handleDateRangeFilter}
                                    quickFilter={quickFilter}
                                />
                            </div>
                            <div className="did-floating-label-content  ms-2 mb-0">
                                <select className="did-floating-select w-150px h-30" onChange={handleViewSelect} value={viewFilter}>
                                    <option value={"groupView"}>Group View</option>
                                    <option value={"touchpointView"}>Touchpoint View</option>
                                </select>

                                {/* <label className="did-floating-label text-nowrap">Data Display</label> */}
                            </div>
                        </div>
                    </div>
                    {/* filter area */}
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9'>
                            <div className='row g-2'>
                                <div className='col-6 col-sm-4 col-md-3 col-lg-3 col-xl-3'>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 pb-2 text-end'>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row g-2'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table custom-table-vertical-center'>
                                                <table className='table table-sm table-bordered mb-2'>
                                                    <thead>
                                                        <tr>
                                                            <th>Summary for</th>
                                                            <th>Net Promoter Score</th>
                                                            <th>Requests</th>
                                                            <th>SMS Sent</th>
                                                            <th>People Contacted	</th>
                                                            <th>Responses</th>
                                                            <th>Response Rate %</th>
                                                            <th>Promoters</th>
                                                            <th>Passives</th>
                                                            <th>Detractors</th>
                                                        </tr>
                                                    </thead>

                                                        <tbody>
                                                            {parentChartData.map((item) => (
                                                                <tr key={item.ParentId}> {/* Adding a unique key for each row */}
                                                                    <td>{item.NpsType}</td>
                                                                    <td >
                                                                        <div className='touchpoint-chart'>
                                                                            <div className='speedometer-chart' style={{ width: '74px', margin: '0 auto' }}>
                                                                                <Speedometer value={item.Nps} color={getNpsColor(item.Nps)} textColor={getNpsColor(item.Nps)} />
                                                                            </div>
                                                                            <div style={{ width: '100px', height: '20px', margin: '-30px auto 0' }}>
                                                                                <StackedSingleBarChart promoters={item.PromotersCount} passives={item.PassivesCount} detractors={item.DetractorsCount} />
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className='text-center'>{item.Requests}</td>
                                                                    <td className='text-center'>
                                                                        {item.Requests}
                                                                        {/* <span><label>Invitations : </label> 682632</span><br /> */}
                                                                        {/* <span><label>Reminders : </label> 0</span> */}
                                                                    </td>
                                                                    <td className='text-center'>{item.PeopleContacted}</td>
                                                                    <td className='text-center'>{item.Responses}</td>
                                                                    <td className='text-center'>{item.ResponseRate}%</td>
                                                                    <td className='text-center'>{item.PromotersCount}</td>
                                                                    <td className='text-center'>{item.PassivesCount}</td>
                                                                    <td className='text-center'>{item.DetractorsCount}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row align-items-center g-2'>
                                        <div className='col-12 col-sm-6 col-md-6'>
                                            <p className='mb-1 ms-0 paginationTotalCount'>Total items: {filteredData.length}</p>
                                            <div className='d-flex align-items-center'>

                                                <label htmlFor="page-size" className='item-per-page'>Items per page:</label>
                                                <select className='form-control-sm did-floating-select h-30 w-50px px-2 me-3' id="page-size" value={itemsPerPage} onChange={handlePageSizeChange}>
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                    <option value={20}>20</option>
                                                </select>
                                                <input className='form-control-sm did-floating-input form-control h-30 w-max-200px'
                                                    type="text"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                    placeholder='Type here to search ...'
                                                />

                                            </div>

                                        </div>

                                        <div className='col-12 col-sm-12 col-md-6'>
                                            <ReactPaginate
                                                previousLabel={'Previous'}
                                                nextLabel={'Next'}
                                                breakLabel={'...'}
                                                pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination'}
                                                activeClassName={'active'}
                                            />
                                        </div>                                     
                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table custom-table-vertical-center'>
                                                      {selectedGroupName != '' && viewFilter == 'groupView'? (
                                                        <table className='table table-sm table-bordered mb-2'>
                                                        <thead>
                                                            <tr>
                                                                {selectedGroupName != '' && viewFilter == 'groupView' ?<th>
                                                                    <Button
                                                                        type='button'
                                                                        onClick={() => handleCustomerGroupBackBtn()}
                                                                        size='sm'
                                                                        className='goBackBtn mb-2 ms-1 me-1'
                                                                    >
                                                                        Go Back
                                                                    </Button>
                                                                </th> : null}
                                                                <th onClick={() => handleSort('LocationName')}>
                                                                    Location Code {sortConfig.key === 'LocationName' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th> 
                                                                <th onClick={() => handleSort('LocationCode')}>
                                                                    Location Name {sortConfig.key === 'LocationCode' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th> 
                                                                <th onClick={() => handleSort('NetPromoterScore')}>
                                                                    Net Promoter Score {sortConfig.key === 'NetPromoterScore' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th onClick={() => handleSort('RatedMedium')}>
                                                                    Rated Medium {sortConfig.key === 'RatedMedium' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('Requests')}>
                                                                    Requests {sortConfig.key === 'Requests' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th onClick={() => handleSort('SMSSent')}>
                                                                    SMS Sent {sortConfig.key === 'SMSSent' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('PeopleContacted')}>
                                                                    People Contacted {sortConfig.key === 'PeopleContacted' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('Responses')}>
                                                                    Responses {sortConfig.key === 'Responses' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('ResponseRate')}>
                                                                    Response Rate %{sortConfig.key === 'ResponseRate' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('Promoters')}>
                                                                    Promoters {sortConfig.key === 'Promoters' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('Passives')}>
                                                                    Passives {sortConfig.key === 'Passives' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                                <th className='text-center' onClick={() => handleSort('Detractors')}>
                                                                    Detractors {sortConfig.key === 'Detractors' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {paginatedData.map((item) => (
                                                                <tr key={item.ChildId}>
                                                                    {selectedGroupName != '' && viewFilter == 'groupView' ? <td></td>:null}
                                                                        <td className='text-center'>{item.LocationCode}</td>
                                                                        <td className='text-center'>{item.LocationName}</td>
                                                                    <td>
                                                                        <div className='touchpoint-chart'>
                                                                            <div className='speedometer-chart' style={{ width: '74px', margin: '0 auto' }}>
                                                                                <Speedometer value={item.Nps} color={getNpsColor(item.Nps)} textColor={getNpsColor(item.Nps)} />
                                                                            </div>
                                                                            <div style={{ width: '100px', height: '20px', margin: '-30px auto 0' }}>
                                                                                <StackedSingleBarChart promoters={item.PromotersCount} passives={item.PassivesCount} detractors={item.DetractorsCount} />
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className='text-center'>{item.RatedMedium}</td>
                                                                    <td className='text-center'>{item.Requests}</td>
                                                                    <td className='text-center'>{item.SmsSent}</td>
                                                                    <td className='text-center'>{item.PeopleContacted}</td>
                                                                    <td className='text-center'>{item.Responses}</td>
                                                                    <td className='text-center'>{item.ResponseRate}%</td>
                                                                    <td className='text-center'>{item.PromotersCount}</td>
                                                                    <td className='text-center'>{item.PassivesCount}</td>
                                                                    <td className='text-center'>{item.DetractorsCount}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                      )
                                                      :
                                                      (
                                                        <table className='table table-sm table-bordered mb-2'>
                                                          <thead>
                                                              <tr>
                                                                  {viewFilter === 'groupView' ? <th onClick={() => handleSort('name')}>
                                                                      Name {sortConfig.key === 'name' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th> : <th onClick={() => handleSort('LocationName')}>
                                                                      {projectFilter.split(',').includes('1') ? 'Location Name' : 'Employee Name'} {sortConfig.key === 'LocationName' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  }
                                                                  {viewFilter === 'touchpointView' ? <th onClick={() => handleSort('LocationCode')}>
                                                                      {projectFilter.split(',').includes('1') ? 'Location Code' : 'Employee Code'} {sortConfig.key === 'LocationCode' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th> : ''}
                                                                  <th onClick={() => handleSort('NetPromoterScore')}>
                                                                      Net Promoter Score {sortConfig.key === 'NetPromoterScore' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th onClick={() => handleSort('RatedMedium')}>
                                                                      Rated Medium {sortConfig.key === 'RatedMedium' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('Requests')}>
                                                                      Requests {sortConfig.key === 'Requests' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th onClick={() => handleSort('SMSSent')}>
                                                                      SMS Sent {sortConfig.key === 'SMSSent' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('PeopleContacted')}>
                                                                      People Contacted {sortConfig.key === 'PeopleContacted' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('Responses')}>
                                                                      Responses {sortConfig.key === 'Responses' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('ResponseRate')}>
                                                                      Response Rate %{sortConfig.key === 'ResponseRate' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('Promoters')}>
                                                                      Promoters {sortConfig.key === 'Promoters' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('Passives')}>
                                                                      Passives {sortConfig.key === 'Passives' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                                  <th className='text-center' onClick={() => handleSort('Detractors')}>
                                                                      Detractors {sortConfig.key === 'Detractors' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                                                                  </th>
                                                              </tr>
                                                          </thead>
                                                          <tbody>
                                                              {paginatedData.map((item) => (
                                                                  <tr key={item.ChildId}>
                                                                      {viewFilter === 'groupView' ? <td className='touchPointDrillableColumn text-center' onClick={() => onGroupNameClick(item.GroupName)}>{item.GroupName}</td>
                                                                          :
                                                                          <td className='text-center'>{item.LocationName}</td>
                                                                      }
                                                                      {viewFilter === 'touchpointView' ? <td className='text-center'>{item.LocationCode}</td> : ''}
                                                                      <td>
                                                                          <div className='touchpoint-chart'>
                                                                              <div className='speedometer-chart' style={{ width: '74px', margin: '0 auto' }}>
                                                                                  <Speedometer value={item.Nps} color={getNpsColor(item.Nps)} textColor={getNpsColor(item.Nps)} />
                                                                              </div>
                                                                              <div style={{ width: '100px', height: '20px', margin: '-30px auto 0' }}>
                                                                                  <StackedSingleBarChart promoters={item.PromotersCount} passives={item.PassivesCount} detractors={item.DetractorsCount} />
                                                                              </div>
                                                                          </div>
                                                                      </td>
                                                                      <td className='text-center'>{item.RatedMedium}</td>
                                                                      <td className='text-center'>{item.Requests}</td>
                                                                      <td className='text-center'>{item.SmsSent}</td>
                                                                      <td className='text-center'>{item.PeopleContacted}</td>
                                                                      <td className='text-center'>{item.Responses}</td>
                                                                      <td className='text-center'>{item.ResponseRate}%</td>
                                                                      <td className='text-center'>{item.PromotersCount}</td>
                                                                      <td className='text-center'>{item.PassivesCount}</td>
                                                                      <td className='text-center'>{item.DetractorsCount}</td>
                                                                  </tr>
                                                              ))}
                                                          </tbody>
                                                      </table>
                                                      )}
                                                      
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </section>
            )}
        </>
    )
}

export default Touchpoint;
